import { filterByKeyWord } from "./filterByKeyword";

import settings from "../../../config.json";

const { searchSettings, dataSettings } = settings;
const { uid } = dataSettings;
const { fieldsToSearch } = searchSettings;

const getFilteredIdsBasedOnPrecisionSearch = (
  tableData,
  precisionSearchQueries
) => {
  /**
   *
   * what do we want to do here?
   *
   * start with
   *   - unfiltered data
   *   - fieldsToSearch
   *   - precision search queries
   *
   * - look at each "field to search"
   *   - check to see if there is a search query for that field
   *      - if so, get the id's of the unfiltered data that match the query
   *
   * - end up with an array of "arrays of ids"
   * - apply an intersection across the arrays
   *
   */

  const arrayOfIds = [];

  let numFieldsWithQuery = 0;

  const precisionSearchFields = [];
  for (const field of fieldsToSearch) {
    if (precisionSearchQueries[field]) {
      precisionSearchFields.push(field);
    }
  }

  if (precisionSearchFields.length === 0) {
    return tableData.map((datum) => datum[uid]);
  }

  for (const field of precisionSearchFields) {
    // check to see if there is a search query for the current field
    const queryForField = precisionSearchQueries[field];

    const queryForFieldExists = queryForField !== "";

    // if so, get the id's of the unfiltered data that match the query
    if (queryForFieldExists) {
      numFieldsWithQuery += 1;

      const keywords = queryForField.split(" ");

      let filteredBySearchString = tableData;

      for (const keyword of keywords) {
        filteredBySearchString = filterByKeyWord(
          keyword.toLowerCase(),
          filteredBySearchString,
          [field]
        );
      }

      const ids = filteredBySearchString.map((datum) => datum[uid]);

      arrayOfIds.push(ids);
    }
  }

  if (numFieldsWithQuery === 0) {
    return tableData.map((datum) => datum[uid]);
  }

  const filteredIdsBasedOnPrecisionSearch = arrayOfIds.reduce((a, b) =>
    a.filter((c) => b.includes(c))
  );

  return filteredIdsBasedOnPrecisionSearch;
};

export { getFilteredIdsBasedOnPrecisionSearch };
